import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentType } from '@types';
import ComponentRenderer from '@helper/ComponentRenderer/ComponentRenderer';
import { ViewSkeleton } from '@widget/loaders';
const UIView = ({ moduleId, componentId, additionalProps }) => {
    return (_jsx("div", { className: "uxpcore_uiview__container", children: _jsx(ComponentRenderer, { moduleId: moduleId, componentId: componentId, type: ComponentType.UI, additionalProps: additionalProps, loader: _jsx(ViewSkeleton, {}) }) }));
};
export default UIView;
